export const environment = {
  production: true,
  url: 'https://listaprecatoriosws.tjba.jus.br/',
  packageFile: './../../../../package.json',
  VERSION: require('../../package.json').version,
  recaptcha: {
    siteKey: '6LdWttAnAAAAAHltNcqBE7ve2yi81sYlImDbxKwv',
  }
};
